import { render, staticRenderFns } from "./le-preview-img.vue?vue&type=template&id=470faeab&scoped=true&"
import script from "./le-preview-img.vue?vue&type=script&lang=js&"
export * from "./le-preview-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470faeab",
  null
  
)

export default component.exports